import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { ModalContainer } from 'components/Modals/ModalContainer';
import { CREATE_DEBATE_MODAL_DATA } from 'shared/constants/modal-constants';
import { CreateDebateForm } from 'components/Forms/CreateDebateForm/CreateDebateForm';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectCurrentModal } from 'redux/selectors/selectors';
import { closeCurrentModal } from 'redux/slices/modals/modals.slice';
import { EModalsNames } from 'shared/types/modal.interface';

export const CreateDebateModal: React.FC = () => {
  const currentModal = useAppSelector(selectCurrentModal);

  const dispatch = useAppDispatch();

  if (currentModal.entityName !== EModalsNames.CreateDebate) return null;

  return (
    <ModalContainer
      onClose={() => dispatch(closeCurrentModal())}
      isOpen={currentModal.entityName === EModalsNames.CreateDebate}
    >
      <Stack alignItems="stretch" width="100%">
        <Typography
          variant="h2"
          color="primary.main"
          alignSelf="center"
          sx={{ mb: { lg: '40px', md: '64px', sm: '64px', xs: '64px' } }}
        >
          {CREATE_DEBATE_MODAL_DATA.title}
        </Typography>
        <CreateDebateForm />
      </Stack>
    </ModalContainer>
  );
};
